var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointEscaleWpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09501,
    y: 13.3745,
    width: 17.0344,
    height: 17.0344,
    transform: "rotate(-45 1.09501 13.3745)",
    fill: "#CFE6E0",
    stroke: "#768C87",
    strokeWidth: 1.54858
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointEscaleWpi);
export default __webpack_public_path__ + "static/media/PointEscaleWPI.34b261599fa351433bb004819b6dac58.svg";
export { ForwardRef as ReactComponent };